import * as React from "react";

const Address = ({ size = 16, color = "#161616" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 12 14"
  >
    <path
      fill={color}
      stroke={color}
      d="M5.657.5c1.368 0 2.68.544 3.647 1.51a5.134 5.134 0 0 1 0 7.26h-.001l-3.54 3.554-.001.001a.167.167 0 0 1-.237 0v-.002L2.01 9.303l-.177-.185A5.157 5.157 0 0 1 5.657.5Zm0 .32a4.808 4.808 0 0 0-3.401 8.202v.001l3.047 3.06.354.355.354-.355 3.047-3.06A4.807 4.807 0 0 0 5.658.82Zm.036 2.461a2.37 2.37 0 0 1 1.673.712L7.372 4a2.33 2.33 0 0 1 .281 2.982 2.375 2.375 0 0 1-4.337-1.337c0-.63.249-1.233.692-1.68v.002a2.37 2.37 0 0 1 1.685-.685Zm.384.345a2.055 2.055 0 0 0-1.532 3.728A2.054 2.054 0 0 0 7.14 7.08l.838-.85h-.345q.09-.279.097-.576v-.01a2.054 2.054 0 0 0-1.653-2.019Z"
    ></path>
  </svg>
);

export default Address;
